'use client'

import { FC } from 'react'
import { QuotesCarousel } from '../_components/granditude'

const quotes = [
  {
    text: "We'd tried three agencies before. They all wanted to sell us their platform. Granditude actually asked what was broken first.",
    author: '— Operations Manager, retail company'
  },
  {
    text: "I didn't think anyone could untangle our Visma and Wikinggruppen setup. I was wrong.",
    author: '— CEO, B2B distributor'
  },
  {
    text: 'They built exactly what we needed, not what they wanted to sell us.',
    author: '— Founder, multi-brand retailer'
  },
  {
    text: 'Without all the flaws we can now focus on our core business.',
    author: '— Ecommerce Manager, production company'
  },
  {
    text: 'Prior we had complex manual work processes. Now everyone understands them.',
    author: '— Business Owner, B2C retailer'
  }
]

export const QuotesSection: FC = () => {
  return <QuotesCarousel quotes={quotes} />
}
